import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
export function UitkRadioButton(props) {
  const wrapperClassNames = classNames(
    "uitk-radio-button",
    props.className,
    { "is-disabled": props.disabled }
  );
  const labelCssClassNames = classNames(
    `uitk-radio-button-label`,
    props.labelClassName,
    {
      "is-required": props.required
    }
  );
  const inputClassNames = classNames({
    checked: props.checked
  });
  const contents = props.label ?? props.children;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: props.style,
      className: wrapperClassNames
    },
    /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "radio",
        name: props.name ?? props.id,
        id: props.id,
        checked: props.checked,
        className: inputClassNames,
        onChange: props.onChange,
        value: props.value,
        disabled: props.disabled
      }
    ),
    /* @__PURE__ */ React.createElement("label", { className: labelCssClassNames, htmlFor: props.id }, /* @__PURE__ */ React.createElement(
      "span",
      {
        "aria-hidden": Boolean(props.a11yLabel),
        className: "uitk-radio-button-label-content"
      },
      contents
    ), props.labelSuffix && /* @__PURE__ */ React.createElement(
      "span",
      {
        "aria-hidden": Boolean(props.a11yLabel),
        className: "uitk-radio-button-label-suffix"
      },
      props.labelSuffix
    ), props.a11yLabel && /* @__PURE__ */ React.createElement("span", { className: "is-visually-hidden" }, props.a11yLabel), props.description && /* @__PURE__ */ React.createElement("p", { className: "uitk-radio-button-description uitk-type-200" }, props.description))
  );
}
UitkRadioButton.displayName = "UitkRadioButton";
